let host = window.location.origin

export default {
    // host: 'https://masgestion-test-nsjkr5dd5a-ew.a.run.app'
    host: host
    // host: 'http://localhost:8000'
}
